import PropTypes from 'prop-types'
import React from 'react'
import classes from './Uoms.scss'
import Button from 'components/Button'
import List from 'components/List'

export const Uoms = (props) => {
  const data = props.uoms.map((uom, index) => ({
    link: `/uoms/${uom.id}/edit`,
    data: [
      uom.name,
      uom.shorthand
    ]
  }))
  const headers = [
    'name',
    'shorthand'
  ]

  return (
    <div className={classes['collection']}>
      <header className={classes['header']}>
        <div className={classes['header-title']}>
          Browsing UOMs
          <span className={classes['header-title--unimportant']}> – {props.uoms.length}</span>
        </div>

        <div className={classes['header-buttons']}>
          <Button options={['green', 'small']} element='a' href='/uoms/new'>
            Add UOM
          </Button>
        </div>
      </header>

      <List data={data} headers={headers} />
    </div>
  )
}

Uoms.propTypes = {
  uoms: PropTypes.array.isRequired
}

Uoms.defaultProps = {
  uoms: []
}

export default Uoms



// WEBPACK FOOTER //
// ./src/components/Uoms/Uoms.js